import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-no-content',
	templateUrl: './no-content.component.html',
	styleUrls: ['./no-content.component.css']
})
export class NoContentComponent implements OnInit
{

	constructor()
	{
	}

	ngOnInit()
	{
	}

}



// WEBPACK FOOTER //
// ./src/app/no-content/no-content.component.ts